import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const get = async (id) => {
  return await httpClient.get(`/term_director_validation_document/${id}/`);
};

const getCounters = async (query) => {
  return await httpClient.get(
    `term_director_validation_document/counters${query}`,
  );
};

const sign = async (id) => {
  return await httpClient.patch(
    `/term_director_validation_document/${id}/sign/`,
  );
};

const reject = async (id, data) => {
  return await httpClient.patch(
    `/term_director_validation_document/${id}/reject/`,
    data,
  );
};

const signSelected = async (data, params) => {
  return await httpClient.patch(
    `/term_director_validation_document/selected/`,
    data,
    makeFilterParams(params),
  );
};

const signMassive = async (params) => {
  return await httpClient.patch(
    `/term_director_validation_document/massive/`,
    {},
    makeFilterParams(params),
  );
};

const rejectSelected = async (data, params) => {
  return await httpClient.patch(
    `/term_director_validation_document/reject_selected/`,
    data,
    makeFilterParams(params),
  );
};

const rejectMassive = async (data, params) => {
  return await httpClient.patch(
    `/term_director_validation_document/reject_massive/`,
    data,
    makeFilterParams(params),
  );
};

const getGroups = async (params) => {
  return await httpClient.get(
    '/term_director_return_selectors/get_groups/',
    makeFilterParams(params),
  );
};

const getUsers = async (params) => {
  return await httpClient.get(
    '/term_director_return_selectors/get_users/',
    makeFilterParams(params),
  );
};

const returnSelected = async (id, data) => {
  return await httpClient.patch(
    `/term_director_validation_document/${id}/return_selected/`,
    data,
  );
};

const returnMassive = async (id, data) => {
  return await httpClient.patch(
    `/term_director_validation_document/${id}/return_massive/`,
    data,
  );
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `${process.env.REACT_APP_API_HOST}/term_director_validation_document/export` +
        `${query}&sort=${sortBy}` +
        `${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `${process.env.REACT_APP_API_HOST}/term_director_validation_document` +
        `${query}&page[number]=${page}&page[size]=${pageSize}` +
        `&sort=${sortBy}` +
        `${searchBy}`,
    );
};

const getProjects = async (params) => {
  return await httpClient.get('/term_director_selectors/projects/', {
    params: params,
  });
};

const getContractTypes = async (params) => {
  return await httpClient.get('/term_director_selectors/contract_types/', {
    params: params,
  });
};

const getRoles = async (params) => {
  return await httpClient.get('/term_director_selectors/roles/', {
    params: params,
  });
};

const getTerms = async (params) => {
  return await httpClient.get('/term_director_selectors/terms/', {
    params: params,
  });
};

export {
  ajaxTable,
  get,
  sign,
  reject,
  getCounters,
  signSelected,
  signMassive,
  rejectSelected,
  rejectMassive,
  getGroups,
  getUsers,
  returnMassive,
  returnSelected,
  getProjects,
  getContractTypes,
  getRoles,
  getTerms,
};
